<template>
	<svg width="200" height="100" viewBox="0 0 200 100" class="preview-svg">
		<rect width="200" height="100" fill="white" />
		<path d="M 20 80 L 180 80" stroke="#ccc" stroke-width="1"></path>
		<path d="M 20 20 L 20 80" stroke="#ccc" stroke-width="1"></path>
		<path
			d="M 20.019 72.83 C 60.019 72.83 140 21 180 21 L 179.98 19.528 C 139.98 19.528 59.887 20.429 19.887 20.429 L 20.019 72.83 Z"
			fill="#8dc533"
			opacity="0.2"
		/>

		<path
			d="M 28.014 79.584 C 39.506 79.584 44.91 80.207 61.226 74.574 C 67.311 72.473 91.887 61.698 98.268 59.252 C 133.79 45.638 156.135 31.241 180 31.241 L 180 80 L 37.57 79.603 L 28.014 79.584 Z"
			fill="#ff4444"
			opacity="0.2"
		/>

		<path
			d="M 20.465 78.486 C 60.449 78.486 139.957 26.216 179.941 26.216"
			stroke="#333"
			stroke-width="2"
			fill="none"
		/>
	</svg>
</template>
